module.exports = __webpack_public_path__ + "e91000cb59fc72bf57d404e2b2c5ab76.fbx";